import produce from 'immer';
export var getInitialState = function () { return ({
    senderAppsLoading: false,
    senderAppsError: false,
    createLoading: false,
    createError: false,
    deleteLoading: false,
    deleteError: false,
    senderApps: [],
    receiverApps: [],
    receiverAppsLoading: null,
    receiverAppsError: false,
    selectedDataset: '',
    receiverAppTemplates: {},
    receiverAppTemplatesLoading: null,
    receiverAppTemplatesError: false,
}); };
function pushMultiAppsReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_PUSH_MULTI_APPS_REQUEST':
                state.senderAppsLoading = true;
                state.senderAppsError = false;
                break;
            case 'LOAD_PUSH_MULTI_APPS_SUCCESS':
                state.senderAppsLoading = false;
                state.senderAppsError = false;
                state.senderApps = action.senderApps || [];
                break;
            case 'LOAD_PUSH_MULTI_APPS_FAILURE':
                state.senderAppsLoading = false;
                state.senderAppsError = true;
                state.senderApps = [];
                break;
            case 'CREATE_PUSH_MULTI_APP_REQUEST':
                state.createLoading = true;
                state.createError = false;
                break;
            case 'CREATE_PUSH_MULTI_APP_SUCCESS':
                state.createLoading = false;
                state.createError = false;
                break;
            case 'CREATE_PUSH_MULTI_APP_FAILURE':
                state.createLoading = false;
                state.createError = true;
                break;
            case 'DELETE_PUSH_MULTI_APP_REQUEST':
                state.deleteLoading = true;
                state.deleteError = false;
                break;
            case 'DELETE_PUSH_MULTI_APP_SUCCESS':
                state.deleteLoading = false;
                state.deleteError = false;
                state.senderApps = state.senderApps.filter(function (sa) { return sa.id !== action.senderAppId; });
                break;
            case 'DELETE_PUSH_MULTI_APP_FAILURE':
                state.deleteLoading = false;
                state.deleteError = action.error;
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_REQUEST':
                state.receiverAppsLoading = true;
                state.receiverAppsError = false;
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_SUCCESS':
                state.receiverAppsLoading = false;
                state.receiverAppsError = false;
                state.receiverApps = action.receiverApps || [];
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_FAILURE':
                state.receiverAppsLoading = false;
                state.receiverAppsError = true;
                state.receiverApps = [];
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_TEMPLATES_REQUEST':
                state.receiverAppTemplatesLoading = true;
                state.receiverAppTemplatesError = false;
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_TEMPLATES_SUCCESS':
                state.receiverAppTemplatesLoading = false;
                state.receiverAppTemplatesError = false;
                state.receiverAppTemplates = action.receiverAppTemplates || {};
                break;
            case 'LOAD_PUSH_RECEIVER_APPS_TEMPLATES_FAILURE':
                state.receiverAppTemplatesLoading = false;
                state.receiverAppTemplatesError = true;
                state.receiverAppTemplates = {};
                break;
            case 'CLEAR_RECEIVER_APPS':
                state.receiverApps = [];
                break;
            default:
                break;
        }
    });
}
export default pushMultiAppsReducer;
